import { Flex } from '@mantine/core';
import classes from './table-slider.module.css';
export const TrackContainerContent = () => {
    return (<Flex h='100%' w='100%' gap={4}>
      <Flex direction='column' h='100%' w='100%' gap={2}>
        {Array.from({ length: 4 }).map((_, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static content
        <div key={index} className={classes.trackContainerRow}/>))}
      </Flex>
      <Flex direction='column' h='100%' w='100%' gap={2}>
        {Array.from({ length: 4 }).map((_, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static content
        <div key={index} className={classes.trackContainerRow}/>))}
      </Flex>
      <Flex direction='column' h='100%' w='100%' gap={2}>
        {Array.from({ length: 4 }).map((_, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static content
        <div key={index} className={classes.trackContainerRow}/>))}
      </Flex>
    </Flex>);
};
